import { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { colTypesWidths } from '~/components/ui/tables/ag/columnTypes';
import { agTheme } from '~/components/ui/tables/ag/agTheme';
import { colDefsPortfolioCapTable } from './colDefsPortfolioCapTable';
import {
  CapTableResponse,
  endpointCapTableGET,
} from '~/api/def/endpoints/portfolioCompanyEndpoint';
import { useQuery } from '@tanstack/react-query';

export type PortfolioCapTableProps = {
  portfolioCompanyId: string;
};

export const PortfolioCapTable = ({
  portfolioCompanyId,
}: PortfolioCapTableProps) => {
  const gridRef = useRef<AgGridReact<CapTableResponse>>(null);

  const { data, isLoading } = useQuery({
    queryKey: ['capTableGet', portfolioCompanyId],
    queryFn: () => endpointCapTableGET(portfolioCompanyId),
  });

  const rowData = data as CapTableResponse[] | undefined;

  return (
    <div style={{ height: '100%' }}>
      <AgGridReact
        rowData={rowData}
        ref={gridRef}
        loading={isLoading}
        columnDefs={colDefsPortfolioCapTable}
        columnTypes={colTypesWidths}
        tooltipShowDelay={0}
        theme={agTheme}
        suppressContextMenu
        colResizeDefault="shift"
        suppressCellFocus
        onColumnResized={(params) => {
          if (params.finished) params.api.sizeColumnsToFit();
        }}
        autoSizeStrategy={{
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        }}
      />
    </div>
  );
};
